import { observer } from 'mobx-react';
import LoadMore from '../../Pagination/LoadMore';
import { Ready } from './GroupParticipantsStore/Types';
import { hasResults } from '../../Pagination/pagination';
import { when } from '@execonline-inc/maybe-adapter';
import { emptyFragment } from '../../../EmptyFragment';

interface Props {
  loadingMore: (page: number) => void;
  state: Ready;
}

function GroupPagination({ state, loadingMore }: Props) {
  const { metadata } = state.resource.payload.participants;
  return when(hasResults(metadata), metadata)
    .map((m) => (
      <div className="py-5">
        <LoadMore
          metadata={m}
          pageFn={loadingMore}
          displayedCount={state.resource.payload.participants.payload.participants.length}
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(GroupPagination);
